'use strict'

import Workspace from '@/pages/Workspace/WorkspaceList'
import WorkspaceCreate from '@/pages/Workspace/WorkspaceCreate'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/workspaces',
    name: 'WorkspaceList',
    component: Workspace,
    meta: {layout: 'auth'},
    beforeEnter: ifAuthenticated
  },
  {
    path: '/workspaces/new',
    name: 'WorkspaceCreate',
    component: WorkspaceCreate,
    meta: {layout: 'auth'},
    beforeEnter: ifAuthenticated
  }

]



// WEBPACK FOOTER //
// ./src/router/domains/workspace.js